import { SellerProblemStatus } from "@deliverr/inbound-client";

export const SUPPORTED_SELLER_PROBLEM_STATUSES = [
  SellerProblemStatus.CREATED,
  SellerProblemStatus.RESOLVED,
  SellerProblemStatus.ACTION_NEEDED,
  SellerProblemStatus.SUPPORT_CONTACTED,
];
